import React from 'react';
import {z} from 'zod';

import {AddComment} from '@mui/icons-material';

import {Shortcode,ShortcodePropsSchema} from './Shortcode';
import ShortcodeSidebarPanel from './ShortcodeSidebarPanel';

export type ShortcodeProps = z.infer<typeof ShortcodePropsSchema>;

export default {
    label: 'Shortcode',
    icon: <AddComment />,
    type: 'Shortcode',
    defaultData: {
        props: { contents: '[shortcode example-code]' },
        style: {
            fontSize: 16,
            textAlign: null,
            padding: { top: 16, bottom: 16, left: 24, right: 24 },
        },
    },
    SidebarPanel: ShortcodeSidebarPanel,
    Component: Shortcode,
    schema: ShortcodePropsSchema,
};